// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"TaxiFinishedRequest_componentHolder__3r5if"};